"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDevMode = void 0;
const react_use_1 = require("react-use");
function useDevMode(enable) {
    (0, react_use_1.useEffectOnce)(() => {
        if (enable && window) {
            window.__ABSTRACT_BUY_DEV_MODE__ = true;
        }
    });
}
exports.useDevMode = useDevMode;
